import * as ActionTypes from './constants';
import { combineReducers } from 'redux';
import { create } from '../Queries/queryGridReducer';
import { createUploadReducer, uploadEventTypes } from '../../components/UploadFile/reducer';
import { UploadActions } from '../../components/UploadFile/actions';
import { produce } from "immer";

const initialState = {

    order: {},
    //queries:[],
    /*queryGrid:*/
};

const initialStateUI = {
    activeQueryTab: 'open',
    alerts: [],
    selectedAlerts: {},
    orderChaseButtonState: {},
    orderCancelButtonState: {},
    productChaseButtonState: {},
    productCancelButtonState: {},
    isReportDialogOpen: false,
    reports: [],
    isSaving: false,
    showRaiseQueryButton: true
};

export function uiReducer(state = initialStateUI, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.ORDER_DETAILS_RAISE_QUERY:
                draft.showRaiseQueryButton = false;
                break;
            case ActionTypes.ORDER_DETAILS_SUBMIT_RAISE_QUERY_SUCCESS:
            case ActionTypes.ORDER_DETAILS_RAISE_QUERY_CANCELLED:
                draft.showRaiseQueryButton = true;
                break;
            case ActionTypes.ORDER_DETAILS_CHANGE_QUERY_TAB:
                draft.activeQueryTab = action.tabName;
                break;
            case ActionTypes.LOAD_ORDER_DETAILS:
                draft.isLoading = true;
                draft.loadFailed = false;
                draft.requestedOrderId = action.orderId;
                draft.loadedOrderId = undefined;
                break;

            case ActionTypes.LOAD_ORDER_DETAILS_SUCCESS:
                draft.isLoading = false;
                break;
            case ActionTypes.LOAD_ORDER_DETAILS_ERROR:
                draft.isLoading = false;
                draft.loadFailed = true;
                break;
            case ActionTypes.ORDER_DETAILS_SET_ALERT_DATASOURCE:
                draft.alerts = action.alerts;
                draft.loadedOrderId = draft.requestedOrderId; // the alerts are the last part of a load
                draft.selectedAlerts = {};
                break;

            case ActionTypes.ORDER_DETAILS_SELECT_ALERT:
                if (action.value) {
                    var id = action.packageId;
                    draft.selectedAlerts[id] = { value: true };
                    return;
                }

                // check this
                console.log(draft.selectedAlerts)
                delete draft.selectedAlerts[action.packageId];
                break;

            case ActionTypes.ORDER_CHASE:
                draft.orderChaseButtonState[action.info.orderId] = { 'chasing': true, 'showChasedLabel': false, 'chased': false };
                break;
            case ActionTypes.ORDER_CHASE_SUCCESS:
                draft.orderChaseButtonState[action.orderId] = { 'chasing': false, 'showChasedLabel': true, 'chased': false };
                break;
            case ActionTypes.ORDER_CHASE_FAIL:
                draft.orderChaseButtonState[action.orderId] = { 'chasing': false, 'showChasedLabel': false, 'chased': false };
                break;
            case ActionTypes.ORDER_CHASE_HIDE_LABEL:
                draft.orderChaseButtonState[action.orderId] = { 'chasing': false, 'showChasedLabel': false, 'chased': true };
                break;

            case ActionTypes.PACKAGE_CHASE:
                draft.productChaseButtonState[action.item.packageId] = { 'chasing': true, 'showChasedLabel': false, 'chased': false };
                break;
            case ActionTypes.PACKAGE_CHASE_SUCCESS:
                draft.productChaseButtonState[action.packageId] = { 'chasing': false, 'showChasedLabel': true, 'chased': false };
                break;
            case ActionTypes.PACKAGE_CHASE_FAIL:
                draft.productChaseButtonState[action.packageId] = { 'chasing': false, 'showChasedLabel': false, 'chased': false };
                break;
            case ActionTypes.PACKAGE_CHASE_HIDE_LABEL:
                draft.productChaseButtonState[action.packageId] = { 'chasing': false, 'showChasedLabel': false, 'chased': true };
                break;
            case ActionTypes.PACKAGE_CANCEL:
                draft.productCancelButtonState[action.item.packageId] = { 'canceling': true, 'showCancelLabel': false };
                break;
            case ActionTypes.PACKAGE_CANCEL_SUCCESS:
                draft.productCancelButtonState[action.packageId] = { 'canceling': false, 'showCancelLabel': true };
                break;
            case ActionTypes.PACKAGE_CANCEL_FAIL:
                draft.productCancelButtonState[action.packageId] = { 'canceling': false, 'showCancelLabel': false };
                break;
            case ActionTypes.ORDER_CANCEL:
                draft.orderCancelButtonState[action.item.orderId] = { 'canceling': true, 'showCancelLabel': false };
                break;
            case ActionTypes.ORDER_CANCEL_SUCCESS:
                draft.orderCancelButtonState[action.orderId] = { 'canceling': false, 'showCancelLabel': true };
                break;
            case ActionTypes.ORDER_CANCEL_FAIL:
                draft.orderCancelButtonState[action.orderId] = { 'canceling': false, 'showCancelLabel': false };
                break;


            case ActionTypes.LOAD_PACKAGE_REPORTS_SUCCESS:
                draft.isReportDialogOpen = true;
                draft.reports = action.reports;
                break;

            case ActionTypes.CLOSE_PACKAGE_REPORT_DIALOG:
                draft.isReportDialogOpen = false;
                break;
            case ActionTypes.ORDER_DETAILS_ADD_SELECTED_PACKAGES_TO_ORDER:
                draft.isSaving = true;
                break;
            case ActionTypes.ORDER_DETAILS_ADD_SELECTED_PACKAGES_TO_ORDER_SUCCESS:
                draft.isSaving = false;
                break;
        }
    });
}

export function orderReducer(state = initialState, action) {
    if (action.uploadChannel != undefined && action.uploadChannel != ActionTypes.OrderDetailsUploadChannel) {
        return state;
    }
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.LOAD_ORDER_DETAILS_SUCCESS:
                draft.order = action.order;
                break;

            case ActionTypes.ORDER_CANCEL_SUCCESS:
                draft.order.packages.forEach(item => {
                    if (item.status != 3 && item.status != 4 && item.status != 7) {
                        item.status = 6;
                        item.statusString = 'Awaiting Response';
                    }
                });
                break;
        }
    });
}

const orderDetailsReducer = combineReducers({
    ui: uiReducer,
    order: orderReducer,
    queryGrid: create(ActionTypes.OpenQueryGridName), // pass grid name as argument also in that reducer is where datasource of query grid is set
    queryGridClosed: create(ActionTypes.ClosedQueryGridName),
    upload: createUploadReducer(action => {
        if (action.uploadChannel != undefined && action.uploadChannel != ActionTypes.OrderDetailsUploadChannel) {
            return false;
        }

        // A failed delete leaves the file listed as it was: it is still saved, and the error is shown (see
        // orderRequest). The create-order pages instead mark the file failed so it isn't submitted.
        return action.type !== UploadActions.UPLOAD_DELETE_FAILURE;
    })
});

export function isSameOrderId(a, b) {
    return a != undefined && b != undefined && String(a) === String(b);
}

// The page component is reused when navigating /order/A -> /order/B (e.g. from a notification), so
// everything held for A (alerts and their selection, query grids, uploads, raise-query/tab/saving flags)
// is dropped as soon as a different order is requested. Reloading the same order (e.g. after adding
// products) keeps the current state so the page doesn't blank while it refreshes.
export default function reducer(state, action) {
    // Leaving the page keeps its data, which the Add More Products page reuses for the same order, but no
    // order is on screen any more: late upload events are dropped, and reopening any order starts clean.
    if (action.type === ActionTypes.LEAVE_ORDER_DETAILS) {
        return state && { ...state, ui: { ...state.ui, requestedOrderId: undefined } };
    }

    if (action.type === ActionTypes.LOAD_ORDER_DETAILS && state && !isSameOrderId(state.ui.requestedOrderId, action.orderId)) {
        state = undefined;
    }

    // An upload keeps running (and saving to its order) after the user moves to another order, so its
    // progress/success/failure events are dropped unless they are for the order now on screen. Matching
    // on file name alone would let them change a same-named attachment of the new order.
    if (state && isUploadEventForAnotherOrder(state, action)) {
        return state;
    }

    const next = orderDetailsReducer(state, action);

    // Reloading the order (e.g. after adding products) replaces its attachments with the server's list,
    // which doesn't include uploads still running yet; keep those so they can complete.
    if (state && action.type === UploadActions.UPLOAD_INIT && action.uploadChannel == ActionTypes.OrderDetailsUploadChannel) {
        const running = state.upload.uploadedFiles.filter(f => f.progress < 1 && !f.failed
            && !next.upload.uploadedFiles.some(u => u.fileName == f.fileName));
        if (running.length) {
            return { ...next, upload: { ...next.upload, uploadedFiles: next.upload.uploadedFiles.concat(running) } };
        }
    }

    return next;
}

function isUploadEventForAnotherOrder(state, action) {
    return uploadEventTypes.includes(action.type)
        && action.uploadChannel == ActionTypes.OrderDetailsUploadChannel
        && !isSameOrderId(state.ui.requestedOrderId, action.objectId);
}
